/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../app/app.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '@angular/core/src/linker/view_type';
import * as import6 from '@angular/core/src/change_detection/constants';
import * as import7 from '@angular/core/src/linker/component_factory';
import * as import8 from '@angular/router/src/router';
import * as import9 from '../../app/services/LocalStorage.service';
import * as import10 from '../../app/services/login.service';
import * as import11 from '../../app/services/common.service';
import * as import12 from '@angular/core/src/linker/view_container';
import * as import13 from '../../$$_gendir/node_modules/@angular/router/src/directives/router_outlet.ngfactory';
import * as import14 from '../../app/common/errors/error.component';
import * as import15 from './common/errors/error.component.ngfactory';
import * as import16 from '../../app/common/spinner/spinner.component';
import * as import17 from './common/spinner/spinner.component.ngfactory';
import * as import18 from '@angular/router/src/router_outlet_map';
import * as import19 from '@angular/core/src/linker/component_factory_resolver';
import * as import20 from '../../app/common/errors/error.service';
import * as import21 from '../../app/common/spinner/spinner.service';
import * as import22 from '@angular/router/src/directives/router_outlet';
export class Wrapper_AppComponent {
  /*private*/ _eventHandler:Function;
  context:import0.AppComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any) {
    this._changed = false;
    this.context = new import0.AppComponent(p0,p1,p2,p3);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_AppComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_AppComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.AppComponent>;
  _AppComponent_0_3:Wrapper_AppComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_AppComponent_Host0,renderType_AppComponent_Host,import5.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'oa-root',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_AppComponent0(this.viewUtils,this,0,this._el_0);
    this._AppComponent_0_3 = new Wrapper_AppComponent(this.injectorGet(import8.Router,this.parentIndex),this.injectorGet(import9.LocalStorageService,this.parentIndex),this.injectorGet(import10.LoginService,this.parentIndex),this.injectorGet(import11.CommonService,this.parentIndex));
    this.compView_0.create(this._AppComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import7.ComponentRef_<any>(0,this,this._el_0,this._AppComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.AppComponent) && (0 === requestNodeIndex))) { return this._AppComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._AppComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._AppComponent_0_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const AppComponentNgFactory:import7.ComponentFactory<import0.AppComponent> = new import7.ComponentFactory<import0.AppComponent>('oa-root',View_AppComponent_Host0,import0.AppComponent);
const styles_AppComponent:any[] = ([] as any[]);
var renderType_AppComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_AppComponent,{});
export class View_AppComponent0 extends import1.AppView<import0.AppComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  /*private*/ _vc_2:import12.ViewContainer;
  _RouterOutlet_2_5:import13.Wrapper_RouterOutlet;
  _text_3:any;
  _el_4:any;
  compView_4:import1.AppView<import14.ErrorComponent>;
  _ErrorComponent_4_3:import15.Wrapper_ErrorComponent;
  _text_5:any;
  _el_6:any;
  compView_6:import1.AppView<import16.SpinnerComponent>;
  _SpinnerComponent_6_3:import17.Wrapper_SpinnerComponent;
  _text_7:any;
  _text_8:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_AppComponent0,renderType_AppComponent,import5.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','page-wrapper'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n  ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'router-outlet',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._vc_2 = new import12.ViewContainer(2,0,this,this._el_2);
    this._RouterOutlet_2_5 = new import13.Wrapper_RouterOutlet(this.parentView.injectorGet(import18.RouterOutletMap,this.parentIndex),this._vc_2.vcRef,this.parentView.injectorGet(import19.ComponentFactoryResolver,this.parentIndex),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n  ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'oa-error',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_4 = new import15.View_ErrorComponent0(this.viewUtils,this,4,this._el_4);
    this._ErrorComponent_4_3 = new import15.Wrapper_ErrorComponent(this.parentView.injectorGet(import20.ErrorService,this.parentIndex));
    this.compView_4.create(this._ErrorComponent_4_3.context);
    this._text_5 = this.renderer.createText(this._el_0,'\n  ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_0,'oa-spinner-component',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_6 = new import17.View_SpinnerComponent0(this.viewUtils,this,6,this._el_6);
    this._SpinnerComponent_6_3 = new import17.Wrapper_SpinnerComponent(this.parentView.injectorGet(import21.SpinnerService,this.parentIndex));
    this.compView_6.create(this._SpinnerComponent_6_3.context);
    this._text_7 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_8 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.RouterOutlet) && (2 === requestNodeIndex))) { return this._RouterOutlet_2_5.context; }
    if (((token === import14.ErrorComponent) && (4 === requestNodeIndex))) { return this._ErrorComponent_4_3.context; }
    if (((token === import16.SpinnerComponent) && (6 === requestNodeIndex))) { return this._SpinnerComponent_6_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._RouterOutlet_2_5.ngDoCheck(this,this._el_2,throwOnChange);
    this._ErrorComponent_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    this._SpinnerComponent_6_3.ngDoCheck(this,this._el_6,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    this.compView_4.internalDetectChanges(throwOnChange);
    this.compView_6.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this.compView_4.destroy();
    this.compView_6.destroy();
    this._RouterOutlet_2_5.ngOnDestroy();
  }
}


// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.component.ngfactory.ts